import './forgot-password.css';
import Form from 'react-bootstrap/Form';
import FaceIcon from '../images/face-icon.png';
import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Header from '../components/header';
import Loader from '../components/loader';
import CustomToaster from '../components/custom-toaster';
import { postData } from '../utils/apis/api';

const ForgotPassword = () => {
    const [emailId, setEmailId] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState(''); // 'success' or 'error'
    const navigate = useNavigate();

    // Email validation regex
    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    // Handle email input change
    const handleEmailChange = (e) => {
        const email = e.target.value;
        setEmailId(email);
        setError(''); // Clear error when typing

        // Check if email is valid
        if (email && !validateEmail(email)) {
            setError('Please enter a valid email address');
        }
    };

    // Handle button click for sending reset link
    const handleButtonClick = async () => {
        if (!emailId) {
            setError('Email is required');
            return;
        }
    
        if (!validateEmail(emailId)) {
            setError('Please enter a valid email address');
            return;
        }
    
        setIsLoading(true); // Show Loader
        setShowToast(false); // Hide previous toast
        setToastMessage(''); // Clear previous message
    
        const headers = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        };
    
        const data = { email: emailId};
    
        try {
            const response = await postData('/request-password-reset', data, headers);

            if (response.detail === 'Password reset link sent to your registered email') {
                setToastVariant('success'); // Success variant
                setToastMessage('Password reset link sent to your email Id successfully!');
                setShowToast(true);
    
                // Redirect to login page after 3 seconds
                setTimeout(() => {
                    if(sessionStorage.getItem('agentName')){
                        navigate('/?agentName='+sessionStorage.getItem('agentName'));
                      }
                      else{
                        navigate('/');
                      }
                }, 3000);
            } else {
                throw new Error(response.message || 'Failed to send password reset link');
            }
        } catch (error) {
            // Extract error message and ensure it's a string
            const errorMessage =
                typeof error.response?.data?.message === 'string'
                    ? error.response.data.message
                    : typeof error.response?.data?.detail === 'string'
                    ? error.response.data.detail
                    : typeof error.message === 'string'
                    ? error.message
                    : JSON.stringify(error.response?.data) || 'An unknown error occurred';
    
            // Show error toast
            setToastVariant('error'); // Error variant
            setToastMessage(errorMessage);
            setShowToast(true);
        } finally {
            setIsLoading(false); // Hide Loader
        }
    };        

    return (
        <>
            <Header />
            <div className="LoginMain">
                <div className="LoginContainer">
                    <img src={FaceIcon} alt="icon" width="119" height="119" />
                    <h2 className="my-4 LoginText">
                        Enter your registered Email Id to send password recovery link
                    </h2>
                    <Form.Control
                        value={emailId}
                        onChange={handleEmailChange}
                        className="my-3"
                        type="email"
                        placeholder="Enter email Id*"
                        required
                    />
                    {error && <p className="text-danger">{error}</p>}
                    <button
                        onClick={handleButtonClick}
                        disabled={!emailId || !!error}
                        className="ContinueButton col-12"
                    >
                        {isLoading ? 'Sending...' : 'Send link to Email'}
                    </button>
                    <h6 className="mt-2">
                        Click here to return to &nbsp;
                        <Link to={((sessionStorage.getItem('userType') === 'user') && sessionStorage.getItem('agentName')) ? "/?agentName=" + sessionStorage.getItem('agentName') : "/"}
                        >Login</Link> Page
                    </h6>
                </div>
            </div>

            {/* Loader */}
            {isLoading && <Loader />}

            {/* Custom Toast */}
            {toastMessage && (
                <CustomToaster
                    show={showToast}
                    onClose={() => setShowToast(false)}
                    message={toastMessage}
                    type={toastVariant}
                />
            )}
        </>
    );
};

export default ForgotPassword;
